<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { Head, Body, Row, Cell } from "@smui/data-table";
  import IconButton, { Icon } from "@smui/icon-button";
  import Button, { Label } from "@smui/button";
  import Paper, { Title, Subtitle, Content } from "@smui/paper";
  import Card from "@smui/card";
  import { DataTable } from "../components";
  import Fab, { Icon as FabIcon } from "@smui/fab";
  import { exclude } from "@smui/common/exclude.js";
  import { fade } from "svelte/transition";
  import { apiGetMany } from "../httpCommon";

  export let resource;
  export let loadOnMount=true;
  export let records = [];
  export let create = null;
  export let title = null;
  export let topLevel = true;
  export let filter = null;
  export let sort = null;
  export let pageSize;
  export let pageSizes = [10, 20, 50, 100];
  export let loading;
  let pagination = {
    pageSize: pageSize || pageSizes[0],
    pageNo: 1
  };
  console.log("Title: ", title);
  //console.log("pageSize: ", pageSize);

  $: [surface, sfcProps, classname] = topLevel
    ? [Paper, { elevation: 5}, 'top-level']
    : [Card, { variant: "outlined", padded: true }, ''];

  export let path = `/${resource}`;

  export function refresh() {
    getResource();
  }

  async function getResource() {
    try {
      loading = true;
      const resp = await apiGetMany(path, { filter, sort, pagination });
      records = resp.data;
      pagination = resp.pagination;
    } catch (error) {
    } finally {
      loading = false;
    }
  }

  $: props = exclude($$props, [
    "resource",
    "records",
    "path",
    "title",
    "create",
    "filter",
    "sort"
  ]);

  function doCreate() {
    if (create) {
      create();
    } else {
      navigate(`${path}/create`);
    }
  }

  export function edit(id) {
    navigate(`${path}/${id}`);
  }

  function setPage(e) {
    getResource();
  }

  onMount(() => {
    if (loadOnMount) {
      getResource();
    }
  });
</script>

<style>
  .outer {
    position: relative;
    min-height: 150px;
  }
  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    z-index: 4;
    opacity: 0.4;
    transition: opacity 0.5s;
    background: lightgrey;
    justify-content: center;
    align-items: center;
  }

  .overlay span {
    z-index: 8;
    text-align: center;
  }
</style>

{(console.log(`ResourceList ${resource}, loading ${loading}`), '')}
<svelte:component this={surface} {...sfcProps} class='{classname}'>
    <div class="flex">
      <div class="flex wrap">
        <span>{title || ''}</span>
        <slot name="filters" {loading} />
      </div>
      <slot name="actions" {loading}>
        <span class="fd-list-actions">
          <Button on:click={doCreate} class="create-button" disabled={loading}>
            <Icon class="material-icons">add</Icon>
            <Label>create</Label>
          </Button>
        </span>
        {#if !topLevel}
          <div class="fd-list-fab">
            <IconButton on:click={doCreate} disabled={loading}>
              <Icon class="material-icons">add</Icon>
            </IconButton>
          </div>
        {/if}
      </slot>
    </div>

    <div class="outer">
      <DataTable {pagination} {pageSizes} {...props} on:setPage={setPage} {loading}>
        {#if loading}
          <div in:fade|local={{ delay: 500, duration: 500 }} out:fade|local class="overlay">
            <span>Loading....</span>
          </div>
        {/if}
        <slot {loading}>
          <Head>
            <Row />
          </Head>
          <Body />
        </slot>
      </DataTable>
    </div>
</svelte:component>

{#if topLevel}
  <div class="app-fab--absolute fd-list-fab">
    <Fab on:click={doCreate} disabled={loading}>
      <Icon class="material-icons">add</Icon>
    </Fab>
  </div>
{/if}
